import React from 'react';
import { Layout, Button, message, Menu } from 'antd';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';
import { LogoutOutlined, ShopOutlined, GiftOutlined, GoldOutlined } from '@ant-design/icons';

const { Header, Sider, Content } = Layout;

const StoreLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { companySlug } = useParams();

  const handleLogout = () => {
    localStorage.removeItem('store_token');
    localStorage.removeItem('store_admin');
    message.success('已退出登录');
    navigate(`/${companySlug}/store/login`);
  };

  const storeAdmin = JSON.parse(localStorage.getItem('store_admin') || '{}');
  const prefix = `/${companySlug}/store`;

  const menuItems = [
    {
      key: `${prefix}/products`,
      icon: <GoldOutlined />,
      label: '货品管理',
    },
    {
      key: `${prefix}/redemptions`,
      icon: <GiftOutlined />,
      label: '兑换订单',
    },
  ];

  const selectedKey = menuItems.find(item =>
    location.pathname === item.key || location.pathname.startsWith(item.key + '/')
  )?.key || `${prefix}/products`;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <ShopOutlined style={{ fontSize: 20, color: '#8B7355' }} />
          <span style={{ fontSize: 18, fontWeight: 600, color: '#8B7355' }}>
            门店后台
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ color: '#666' }}>
            {storeAdmin.store_name || storeAdmin.username}
          </span>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            退出
          </Button>
        </div>
      </Header>

      <Layout>
        <Sider
          theme="light"
          width={180}
          style={{
            boxShadow: '2px 0 8px rgba(0,0,0,0.06)',
            zIndex: 10
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
            style={{ borderRight: 0, paddingTop: 8 }}
          />
        </Sider>

        <Content style={{
          margin: 24,
          padding: 24,
          background: '#fff',
          borderRadius: 8,
          minHeight: 280
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default StoreLayout;
